import { createFileRoute } from '@tanstack/react-router'
import { resolveLegacyOrganizationsPath } from '@/lib/legacy-routes'
import { redirectFromLegacyPath, splitSplat } from '@/lib/legacy-redirect'

/** Every `/organizations/…` URL the old app could produce. */
export const Route = createFileRoute('/organizations/$')({
  loader: ({ context: { queryClient }, params }) =>
    redirectFromLegacyPath(queryClient, resolveLegacyOrganizationsPath(splitSplat(params._splat))),
})
